export default __webpack_public_path__ + "static/media/dropdownEdit.ea4a6701.svg";